import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

function getCanonicalAppOrigin() {
  if (process.env.NODE_ENV === 'production') {
    const canonicalOrigin = (
      process.env.REACT_APP_CANONICAL_APP_ORIGIN || 'https://platform.quantchecklabs.com'
    ).trim();
    const canonicalHost = new URL(canonicalOrigin).hostname.toLowerCase();
    const currentHost = window.location.hostname.toLowerCase();
    const forceCanonicalHosts = new Set([
      canonicalHost,
      'www.platform.quantchecklabs.com',
      'quantchecklabs.com',
      'www.quantchecklabs.com',
      'react-qcl-website.vercel.app',
      'www.react-qcl-website.vercel.app',
    ]);

    if (forceCanonicalHosts.has(currentHost)) {
      return canonicalOrigin;
    }
  }

  return window.location.origin;
}

function buildAppUrl(pathname) {
  return new URL(pathname, getCanonicalAppOrigin()).toString();
}

export function getAuthCallbackUrl() {
  return buildAppUrl('/login-callback');
}

export function getPasswordResetRedirectUrl() {
  return buildAppUrl('/login?reset=success');
}

export function getCallbackUrl() {
  return getAuthCallbackUrl();
}
